module.exports = __webpack_public_path__ + "img/PPT.1e29ebed.png";